// src/components/PostAdFeatureModal.js
import React, { useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSearch } from '@fortawesome/free-solid-svg-icons';


const PostAdFeatureModal = ({
  isOpen,
  onClose,
  type,
  currentLanguage,
  getLocalizedText,
  onSelect
}) => {
  const t = (ar, en) => getLocalizedText(ar, en);

  const [searchTerm, setSearchTerm] = useState('');

  let title = '';
  let allItems = [];

  if (type === 'metro') {
    title = t('محطات المترو', 'Metro Stations');
    allItems = require('../constants/features').metroStations;
  } else if (type === 'university') {
    title = t('الجامعات', 'Universities');
    allItems = require('../constants/features').universities;
  } else if (type === 'square') {
    title = t('الميادين', 'Squares');
    allItems = require('../constants/features').squares;
  }

  const filteredItems = useMemo(() => {
    if (!searchTerm.trim()) return allItems;

    const term = searchTerm.toLowerCase().trim();
    return allItems.filter(item => {
      const arabicText = (item.ar || '').toLowerCase();
      const englishText = (item.en || '').toLowerCase();
      return arabicText.includes(term) || englishText.includes(term);
    });
  }, [searchTerm, allItems]);

  if (!isOpen) return null;

  const handleSelect = (item) => {
    // حالياً مفيش حاجة تحصل (كما طلبت)
    console.log('Selected from PostAdFeatureModal:', item);
    
    if (onSelect) {
      onSelect({
        ...item,
        address: getLocalizedText(item.ar, item.en),
        lat: item.lat,
        lng: item.lng
      });
    }
    onClose();
  };

  const clearSearch = () => setSearchTerm('');

  return (
    <div className="feature-modal-overlay" onClick={onClose}>
      <div 
        className={`feature-modal ${currentLanguage === 'ar' ? 'ar' : 'en'}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="feature-modal-header">
          <h2>{title}</h2>
          <button className="feature-modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="feature-modal-search">
          <div className="search-input-wrapper">
            <FontAwesomeIcon icon={faSearch} className="search-icon" />
            <input
              type="text"
              placeholder={currentLanguage === 'ar' ? "ابحث هنا..." : "Search here..."}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="feature-search-input"
            />
            {searchTerm && (
              <button className="search-clear-btn" onClick={clearSearch}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            )}
          </div>
        </div>

        <div className="feature-modal-body">
          <div className="feature-list">
            {filteredItems.length > 0 ? (
              filteredItems.map((item, index) => (
                <div
                  key={index}
                  className="feature-item"
                  onClick={() => handleSelect(item)}
                >
                  <span>{getLocalizedText(item.ar, item.en)}</span>
                </div>
              ))
            ) : (
              <div className="no-results">
                {currentLanguage === 'ar' ? "لا توجد نتائج مطابقة" : "No matching results"}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostAdFeatureModal;